export const EDIT_ALL = 'edit:all'
export const MANAGE_ALL = 'manage:all'
